import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { TopNavigation } from "@cloudscape-design/components";

const Header = () => {
  const { user, logout } = useAuth();
  const [activeHref, setActiveHref] = useState(window.location.pathname);

  const handleFollow = (event) => {
    setActiveHref(event.detail.href);
  };

  const handleLogout = () => {
    logout();
    setActiveHref("/");
  };

  const utilities = user
    ? [
        {
          type: "button",
          text: "Profile",
          href: "/profile",
          external: false,
        },
        {
          type: "button",
          text: "Logout",
          onClick: handleLogout,
        },
      ]
    : [
        {
          type: "button",
          text: "Login",
          href: "/login",
          external: false,
        },
        {
          type: "button",
          text: "Register",
          href: "/register",
          external: false,
        },
      ];

  return (
    <TopNavigation
      identity={{
        href: "/",
        title: "EE Analytics",
        logo: {
          src: "/logo192.png",
          alt: "EE Analytics",
        },
      }}
      utilities={utilities}
      i18nStrings={{
        searchIconAriaLabel: "Search",
        searchDismissIconAriaLabel: "Close search",
        overflowMenuTriggerText: "More",
        overflowMenuTitleText: "More",
        overflowMenuBackIconAriaLabel: "Back",
        overflowMenuDismissIconAriaLabel: "Close menu",
      }}
      onFollow={handleFollow}
      activeHref={activeHref}
      items={[
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Stats",
          href: "/stats",
        },
        {
          text: "Health",
          href: "/health",
        },
      ]}
    />
  );
};

export default Header;
